import styled from 'styled-components';
import MuiButton from '@material-ui/core/Button';

export const Container = styled(MuiButton)`
  padding: 9px 16px;
  font-size: 14px;

  &.MuiButton-sizeSmall {
    padding: 6px 16px;
  }

  &:hover {
    background: #F9F5FA;
  }

  &:focus {
    box-shadow: 0 0 0 1px #D38DDE;
  }

  .MuiButton-label {
    font-weight: bold;
    text-transform: none;
  }

  &.Mui-disabled {
    color: #525866 !important;
  }

  &.MuiButton-text {
    color: #26427C;
  }

  &.MuiButton-outlined {
    border: 1px solid #CFD6E6;

    &:focus {
      border: 1px solid #D38DDE;
      box-shadow: none;
    }

    .MuiTouchRipple-child {
      background:#fff;
    }

    &.purple {
      color: #8A5C91;
      border-color: #8A5C91;
    }

    &.blue {
      color: #6699FF;
      border-color: #6699FF;
    }

    &.green {
      color: #30BF78;
      border-color: #30BF78;
    }

    &.red {
      color: #CC2942;
      border-color: #CC2942;
    }
  }

  &.MuiButton-contained {
    color: #fff;
    box-shadow: none !important;

    .MuiTouchRipple-root {
      display: none;
    }

    &.Mui-disabled {
      background: #F5F7FA;
    }

    &.blue {
      background: #6699FF;
    }

    &.green {
      background: #30BF78;
    }

    &.red {
      background: #CC2942;
    }

    &.purple {
      background: #8A5C91;
    }
  }
`;
